<template>
  <div class="wrapper">
    <template v-if="isAuth">
    <side-bar>
      <template slot="links"> 
        <a class="sideber-title-learge">All-Entities</a>
        <a class="sideber-title-small">Global MD Meeting</a>
        <sidebar-link to="/current_status" name="Current Status" icon="ti-dashboard"/>
        <sidebar-link to="/global_sales" name="Sales" icon="ti-money"/>
        <sidebar-link to="/global_customers" name="Customers" icon="ti-comments-smiley"/>
        <sidebar-link to="/global_trainings" name="Trainings" icon="ti-pencil-alt"/>
        <a class="sideber-title-small">datastudio information</a>
        <sidebar-link to="/idn_datastudio" name="Datastudio(IDN)" icon="ti-google"/>
        <sidebar-link to="/jp_datastudio" name="Datastudio(JP)" icon="ti-google"/>
        <sidebar-link to="/kr_datastudio" name="Datastudio(KR)" icon="ti-google"/>
        <sidebar-link to="/my_datastudio" name="Datastudio(MY)" icon="ti-google"/>
        <sidebar-link to="/sg_datastudio" name="Datastudio(SG)" icon="ti-google"/>
      </template>
      <template slot="links">
        <div class="icon-container  clickable" @click="toggleDropDown" >
            <a class="sideber-title-learge">JP Entity</a>
            <span :class=jpicon></span>
        </div>
        <template v-if="isVisibleJp">
          <a class="sideber-title-small">Voyage by All</a>
          <sidebar-link to="/souffle-contributions" name="Contributions" icon="ti-control-shuffle"/>
          <a class="sideber-title-small">Captain Meeting</a>
          <sidebar-link to="/jp_sales" name="Sales" icon="ti-money"/>
          <sidebar-link to="/jp_customers" name="Customers" icon="ti-comments-smiley"/>
          <sidebar-link to="/jp_trainings" name="Trainings" icon="ti-pencil-alt"/>
          <a class="sideber-title-small">SBU Activities Check</a>
          <sidebar-link to="/happiness" name="Happiness" icon="ti-heart"/>
          <sidebar-link to="/growth" name="Growth" icon="ti-stats-up"/>
          <a class="sideber-title-small">Souffle Check</a>
          <sidebar-link to="/souffle-activities" name="Activities" icon="ti-control-forward"/>
          <sidebar-link to="/souffle-discretions" name="Discretions" icon="ti-rocket"/>
        </template>
      </template>
      <mobile-menu>
      </mobile-menu>
    </side-bar>
    <div class="main-panel">
      <top-navbar v-bind:user="user" @navLogOut="logOut"></top-navbar>
      <dashboard-content @click.native="toggleSidebar"></dashboard-content>
    </div>
    </template>
    <template v-else>
       <login-content></login-content>
    </template>
  </div>
</template>
<style lang="scss">
</style>
<script>
import TopNavbar from "./TopNavbar.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
import LoginContent from "../../pages/Login.vue";
import firebase from 'firebase/app'
export default {
  data() {
    return {
      user: {},
      jpicon: "",
      isAuth: false,
      isVisibleJp: false, 
    }
  },
  components: {
    TopNavbar,
    DashboardContent,
    MobileMenu,
    LoginContent,
  },
  mounted() {
    if (localStorage.isVisibleJp === 'true'){
      this.isVisibleJp = true
    }
    if (this.isVisibleJp) {
      this.jpicon = "ti-minus"
    } else{
      this.jpicon = "ti-plus"
    }
  },
  beforeMount: function () {
    firebase.auth().onAuthStateChanged((user) => {
      this.user = user ? user : {}
      if (user) {
        console.log('login');
        console.log(user);
        this.isAuth= true;
      } else {
        console.log('logout');
        this.isAuth = false;
      }
    }); 
  },
  watch:{
    isVisibleJp(visible) {
      localStorage.isVisibleJp = visible;
    }
  },
  methods: {
    logOut(){
        firebase.auth().signOut()
    },
    toggleDropDown() {
      this.isVisibleJp = !this.isVisibleJp;
      if (this.isVisibleJp) {
        this.jpicon = "ti-minus"
      } else{
        this.jpicon = "ti-plus"
      }
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>
